import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Zoom from "@mui/material/Zoom";
import styled from "styled-components";

const InfoButton = styled(Button)`
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50% !important;
    min-width: unset !important;
    padding: unset !important;
`;

export default function InfoTooltip({ text }: { text: string }) {
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return (
        <div>
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <div>
                    <Tooltip
                        PopperProps={{
                            disablePortal: true,
                        }}
                        onClose={handleTooltipClose}
                        open={open}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title={
                            typeof text === "object" ? (
                                text
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{ __html: text }}
                                />
                            )
                        }
                        TransitionComponent={Zoom}
                        placement="right"
                    >
                        <InfoButton
                            variant="contained"
                            color="tooltip"
                            onClick={handleTooltipOpen}
                        >
                            <FontAwesomeIcon
                                icon={faInfo}
                                color="white"
                                size="sm"
                            />
                        </InfoButton>
                    </Tooltip>
                </div>
            </ClickAwayListener>
        </div>
    );
}
